import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Endpoints } from '../../../../../apis';
import { getErrorMessage } from '@xver/utils/error';

export function useAddSSHKeyMutation() {
    const { t } = useTranslation('notifications');
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: Endpoints.v1.SSHKeys.addSSHKey,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['api.v1.ssh-keys.get'] });
            notifications.show({
                title: t('sshKey.addedTitle'),
                message: t('sshKey.addedMessage'),
                icon: <IconCheck size={32} color={'#00ff00'} />,
            });
        },
        onError: (error: any) => {
            notifications.show({
                title: t('sshKey.addFailedTitle'),
                message: getErrorMessage(error),
                icon: <IconExclamationCircle size={32} color={'#eb5757'} />,
            });
        },
    });
}
